import React from "react";
import { Button, Modal } from "react-bootstrap";
import { EditAllItemsForm } from "./form";

export function ModalEditAllItems({show, setShow, name}){

  return (
    <Modal 
      show={show} 
      onHide={()=>setShow(false)}
      scrollable 
      size='xl' 
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Language Entry: {`(${name})`}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{padding:0}}>
        <EditAllItemsForm name={name}/>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button>Confirm</Button> */}
        <Button onClick={()=>setShow(false)}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}